module.exports = __webpack_public_path__ + "static/ex_java_string-e768f0b23403c4c3d70773954ce2cbf3.png";